export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/categorias', {
            titulo: dados.titulo,
            titulo_url: dados.titulo_url,
            status: dados.status,
        }, { headers });
        return {
            data: response.data
        }
    },
    update: async ({ dados, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.put('/categorias/' + dados.id, dados, { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias/' + id, { headers });
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias', { headers });
        return {
            data: response.data
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/categorias/' + id, { headers });
        return {
            data: response
        }
    },
    getAllCategoriasPropagandas: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categoria-propagandas', { headers });
        return {
            data: response.data
        }
    },
    saveCatPropaganda: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.post('/categoria-propagandas', {
            nome: dados.nome,
            dimensoes: dados.dimensoes,
            pagina: dados.pagina,
            posicao: dados.posicao,
        }, { headers });
        return {
            data: response.data
        }
    },
    deleteCatPropaganda: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/categoria-propagandas/' + id, { headers });
        return {
            data: response
        }
    },
});